module.exports = __webpack_public_path__ + "img/qbe.2b87f048.svg";